import CloseIcon from '@mui/icons-material/CloseOutlined';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import {
  generalFollowActions,
  getBrandCodeOfProduct
} from 'src/store/slices/generalFollowSlice';
import axios from 'src/utils/axios';
import InputAdornment from '@mui/material/InputAdornment';
import AlertAndLoading from 'src/components/AlertAndLoading';
import { confirmAlert } from 'react-confirm-alert';
import OlizIcon from 'src/assets/images/Oliz.png';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    fontFamily: 'Segoe UI'
  },
  cardscontentInfo: {
    minHeight: 250
  },
  content: {
    justifyContent: 'space-between'
  },
  panelsContent: {
    minHeight: 260
  },
  mainCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    backgroundColor: '#f5f5f5',
    boxShadow: 'none',
    marginBottom: '16px'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    borderRadius: '12px',
    padding: '12px 16px',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: 500
    }
  }
}));

const NumberFormatCustom = React.forwardRef(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value || 0
            }
          });
        }}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={2}
        allowNegative={false}
        isNumericString
        suffix="₺"
      />
    );
  }
);

function DifferentModelSuggest() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );
  const offerProductPrice = useSelector(
    (state) => state.generalFollowSlice.updatedOfferPrice
  );
  const topModelDifferentPrice = useSelector(
    (state) => state.generalFollowSlice.updatedTopModelDifferentPrice
  );

  const subModelDifferenceAmount = useSelector(
    (state) => state.generalFollowSlice.updatedSubModelDifferenceAmount
  );

  const giveProductPriceSelector = useSelector(
    (state) => state.generalFollowSlice.updatedGiveProductPrice
  );

  const receivedProductPriceSelector = useSelector(
    (state) => state.generalFollowSlice.updatedReceivedProductPrice
  );

  const updateInvoiceChangedSelector = useSelector(
    (state) => state.generalFollowSlice.updatedInvoiceChanged
  );

  const [expanded, setExpanded] = React.useState(true);
  const [giveStokNumber, setGiveStokNumber] = React.useState(
    invoiceData[0]?.Exchange?.GiveProductStokNumber
      ? invoiceData[0]?.Exchange?.GiveProductStokNumber
      : invoiceData[0]?.Model?.UserModelCode
  );

  const handleToggleCollapse = () => {
    setExpanded(!expanded);
  };
  const [giveProductDesc, setGiveProductDesc] = React.useState(
    invoiceData[0]?.Exchange?.GiveProductDesc
      ? invoiceData[0]?.Exchange?.GiveProductDesc
      : ''
  );
  const [giveProductPrice, setGiveProductPrice] = React.useState(
    invoiceData[0]?.Exchange?.GiveProductPrice
      ? invoiceData[0]?.Exchange?.GiveProductPrice
      : 0
  );
  const [olizPriceGiveProduct, setOlizPriceGiveProduct] = React.useState(0);

  const [stockTotal, setStockTotal] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [BuyStokNumber, setBuyStokNumber] = React.useState(
    invoiceData[0]?.Model?.RevisionStokNo
      ? invoiceData[0]?.Model?.RevisionStokNo
      : ''
  );
  const [buyProductDesc, setBuyProductDesc] = React.useState(
    invoiceData[0]?.Model?.ProductDesc ? invoiceData[0]?.Model?.ProductDesc : ''
  );
  const [buyProductPrice, setBuyProductPrice] = React.useState(
    invoiceData[0]?.Exchange?.ReceivedProductPrice
      ? invoiceData[0]?.Exchange?.ReceivedProductPrice
      : 0
  );
  // const [buyProductWholesalePrice, setBuyProductWholesalePrice] =
  //   React.useState(0);
  const [giveProductWholesalePrice, setGiveProductWholesalePrice] =
    React.useState(0);
  const [buyStockTotal, setBuyStockTotal] = React.useState(0);
  const [stockRegionName, setStockRegionName] = React.useState('');

  const [responseMessage, setresponseMessage] = React.useState('');
  const [uyari, setUyari] = React.useState(false);
  const [alertType, setAlertType] = React.useState({
    ErrorType: 'error',
    ErrorTitle: 'Uyarı'
  });

  const totalProductPrice =
    parseFloat(topModelDifferentPrice) +
    parseFloat(offerProductPrice) +
    (parseFloat(invoiceData[0]?.Exchange?.OderoFuturesPrice) || 0); //Ödero Vade Farkı Tutarı

  useEffect(() => {
    if (updateInvoiceChangedSelector) {
      changeGiveProductPriceSelector(giveProductPriceSelector);
      changeReceviedProductPriceSelector(receivedProductPriceSelector);
      dispatch(generalFollowActions.updateInvoiceChanged(false));
    }
  }, [updateInvoiceChangedSelector]);

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    });
    setUyari(true);
    return;
  }
  function changeReceviedProductPriceSelector(val) {
    //verilen ürün stok numarası
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.ReceivedProductPrice = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setBuyProductPrice(val);
  }

  function changeGiveProductPriceSelector(val) {
    //verilen ürün stok numarası
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.GiveProductPrice = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setGiveProductPrice(val);
  }

  function changeGiveStokNumber(val) {
    //verilen ürün stok numarası
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.GiveProductStokNumber = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setGiveStokNumber(val);
  }

  function changeBuyStokNumber(val) {
    //Alınan ürün stok numarası
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Model.RevisionStokNo = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setBuyStokNumber(val);
  }

  function changeGiveStokProductDesc(val) {
    //verilen ürün açıklama
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.GiveProductDesc = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setGiveProductDesc(val);
  }

  function changeBuyStokProductDesc(val) {
    //Alınan ürün açıklama
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Model.ProductDesc = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setBuyProductDesc(val);
  }

  function changeGiveProductPrice(val) {
    //verilen prekande fiyat
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    if (invoiceData[0]?.Consumer?.UpTypeId === 1) {
      tempData[0].Exchange.ReceivedProductPrice = val;
      setBuyProductPrice(val);
    } else if (invoiceData[0]?.Consumer?.UpTypeId === 3) {
      let fark = val - totalProductPrice;
      if (fark < 0) {
        fark = 0;
      }
      tempData[0].Exchange.ReceivedProductPrice = fark;
      setBuyProductPrice(fark);
    } else if (
      invoiceData[0]?.Consumer?.UpTypeId === 6 &&
      invoiceData[0]?.Consumer?.ConsumerType === 1
    ) {
      let fark =
        val - totalProductPrice + (parseFloat(subModelDifferenceAmount) || 0);
      if (fark < 0) {
        fark = 0;
      }
      tempData[0].Exchange.ReceivedProductPrice = fark;
      setBuyProductPrice(fark);
    } else {
      tempData[0].Exchange.GiveProductPrice = val;
      setGiveProductPrice(val);
    }
    tempData[0].Exchange.GiveProductPrice = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setGiveProductPrice(val);
    // var tempData = JSON.parse(JSON.stringify(invoiceData))
    // tempData[0].Exchange.GiveProductPrice = val
    // dispatch(generalFollowActions.updateNewData(tempData))
    // setGiveProductPrice(val)
  }

  function changeBuyProductPrice(val) {
    //alınan ürün prekande fiyat
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.ReceivedProductPrice = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setBuyProductPrice(val);
  }

  // function changeBuyProductWholesalePrice(val) {
  //   //alınan ürün toptan fiyat
  //   setBuyProductWholesalePrice(val);
  // }

  // function changeGiveProductWholesalePrice(val) {
  //   //verilen ürün toptan fiyat
  //   setGiveProductWholesalePrice(val);
  // }

  function changeGiveStokTotal(val) {
    //verilen ürün stok adet
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.stokTotal = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setStockTotal(val);
  }

  function buyProductPriceCalculate(val) {
    // Verilen Perakende Fiyat Hesaplama
    if (invoiceData[0]?.Consumer?.UpTypeId === 1) {
      changeBuyProductPrice(val);
    }
    if (invoiceData[0]?.Consumer?.UpTypeId === 3) {
      let fark = val - totalProductPrice;
      changeBuyProductPrice(fark);
    }
    changeGiveProductPrice(val);
  }

  // function buyProductPriceCalculateButton() { // Sorgula Butonunun Arkasında Verilen Perakende Fiyat Hesaplama
  //   let value = giveProductPrice
  //   buyProductPriceCalculate(value);
  // }

  function diffModelStokControl() {
    if (giveStokNumber.length <= 0) {
      return;
    }
    const data = [
      giveStokNumber?.trim()?.toString() || null,
      invoiceData[0]?.Model?.RevisionStokNo?.toString() || null,
      null,
      null,
      invoiceData[0]?.Exchange?.Service,
      invoiceData[0]?.Apply?.ReceiptNumber
    ];
    setLoading(true);
    axios
      .get(
        `/GetProductPrice/${data[0]}/${data[1]}/${data[2]}/${data[3]}/${data[4]}/${data[5]}`,
        {}
      )
      .then((response) => {
        var tempData = JSON.parse(JSON.stringify(invoiceData));
        tempData[0].Exchange.GiveProductDesc =
          response.data.GiveProductStokDesc;
        tempData[0].Exchange.GiveProductPrice =
          response.data.GiveProductStokPrice;
        tempData[0].Exchange.GiveProductStokNumber =
          response.data.GiveProductStokNumber;
        tempData[0].Exchange.ReceivedProductPrice =
          response.data.ProductBuyStockPrice;

        dispatch(generalFollowActions.updateNewData(tempData));
        setGiveProductDesc(response.data.GiveProductStokDesc);
        setGiveStokNumber(response.data.GiveProductStokNumber);
        setGiveProductPrice(response.data.GiveProductStokPrice);
        setGiveProductWholesalePrice(
          response.data.GiveProductWholeSalePrice || 0
        );
        setStockTotal(response.data.StoreStockTotal);
        setBuyStokNumber(response.data.ProductGetStockNumber);
        setStockRegionName(response.data.StoreStockName);
        setBuyProductDesc(response.data.ProductGetStockDesc);
        setBuyProductPrice(response.data.ProductBuyStockPrice);

        setOlizPriceGiveProduct(response.data.OlizPriceGiveProduct || 0);
        // setBuyProductWholesalePrice(
        //   response.data.ProductBuyWholeSalesPrice || 0
        // );

        const currentData = tempData;

        //MHTU-3836 Ürün Açıklama Güncellenmesi içindir.
        var giveProductDescription = tempData[0].Exchange.GiveProductDesc;
        var giveProductStokNum = tempData[0].Exchange.GiveProductStokNumber;
        var giveProductPrice = tempData[0].Exchange.GiveProductPrice;

        let fark = 0;
        var buyProductPrice = 0;

        if (invoiceData[0]?.Consumer?.UpTypeId === 1) {
          buyProductPrice = response.data.GiveProductStokPrice;
          setBuyProductPrice(response.data.GiveProductStokPrice);
        }
        if (invoiceData[0]?.Consumer?.UpTypeId === 3) {
          fark = response.data.GiveProductStokPrice - totalProductPrice;
          if (fark < 0) {
            fark = 0;
          }
          buyProductPrice = fark;
          setBuyProductPrice(fark);
        }
        if (
          invoiceData[0]?.Consumer?.UpTypeId === 6 &&
          invoiceData[0]?.Consumer?.ConsumerType === 1
        ) {
          let fark =
            response.data.GiveProductStokPrice -
            totalProductPrice +
            (parseFloat(subModelDifferenceAmount) || 0);
          if (fark < 0) {
            fark = 0;
          }
          buyProductPrice = fark;
          setBuyProductPrice(fark);
        }
        setLoading(false);

        //MHTU-3836 BAŞLANGIÇ
        if (
          giveProductStokNum &&
          invoiceData[0]?.Exchange?.IsManagerAppliedDifferenBrand === 0
        ) {
          dispatch(getBrandCodeOfProduct(giveProductStokNum.toString())).then(
            (response) => {
              if (response.payload?.length > 0) {
                var BrandCode = response.payload[0]?.MARKA_KODU;
                if (BrandCode !== invoiceData[0]?.Apply.BrandCode) {
                  confirmAlert({
                    message:
                      'Farklı Marka Ürün Seçtiniz! Yönetici Onayı Alarak Devam Edebilirsiniz. Devam Etmek istiyor musunuz?',
                    buttons: [
                      {
                        label: 'Devam Et',
                        onClick: () => {
                          var tempData = JSON.parse(
                            JSON.stringify(invoiceData)
                          );
                          tempData[0].Exchange.DifferentBrandManagerControl = 1;
                          tempData[0].Exchange.GiveProductStokNumber =
                            giveProductStokNum;
                          tempData[0].Exchange.GiveProductDesc =
                            giveProductDescription;
                          tempData[0].Exchange.GiveProductPrice =
                            giveProductPrice;
                          tempData[0].Exchange.ReceivedProductPrice =
                            buyProductPrice;
                          dispatch(
                            generalFollowActions.updateNewData(tempData)
                          );
                        }
                      },
                      {
                        label: 'Vazgeç',
                        onClick: () => {
                          var tempData = JSON.parse(
                            JSON.stringify(invoiceData)
                          );
                          tempData[0].Exchange.DifferentBrandManagerControl = 0;
                          tempData[0].Exchange.GiveProductStokNumber = null;
                          tempData[0].Exchange.GiveProductDesc = null;
                          tempData[0].Exchange.GiveProductPrice = null;
                          tempData[0].Exchange.ReceivedProductPrice =
                            buyProductPrice;
                          setGiveStokNumber([]);
                          setGiveProductDesc([]);
                          setGiveProductPrice(0);
                          dispatch(
                            generalFollowActions.updateNewData(tempData)
                          );
                        }
                      }
                    ],
                    closeOnEscape: false,
                    closeOnClickOutside: false
                  });
                } else {
                  var tempData = JSON.parse(JSON.stringify(currentData));
                  tempData[0].Exchange.DifferentBrandManagerControl = 0;
                  tempData[0].Exchange.ReceivedProductPrice = buyProductPrice;
                  tempData[0].Exchange.GiveProductStokNumber =
                    giveProductStokNum;
                  tempData[0].Exchange.GiveProductDesc = giveProductDescription;
                  tempData[0].Exchange.GiveProductPrice = giveProductPrice;
                  dispatch(generalFollowActions.updateNewData(tempData));
                }
              }
            }
          );
        }
        //MHTU-3836 BİTİŞ

        if (response.data.isProductControl == 1) {
          InfoAlert(
            'Değişim Grubunda Üründe şu anda kalite problemi mevcut...',
            'info',
            'Bilgilendirme'
          );
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  return (
    <>
      <AlertAndLoading
        Message={responseMessage}
        open={uyari}
        AlertType={alertType}
        onClose={uyariKapat}
        loading={loading}
      />
      <Card className={classes.mainCard}>
        <CardHeader
          className={classes.cardHeader}
          avatar={
            <DragIndicatorIcon sx={{ color: '#FF9800', fontSize: '20px' }} />
          }
          action={
            <Tooltip title={expanded ? 'Daralt' : 'Genişlet'}>
              <IconButton
                onClick={handleToggleCollapse}
                sx={{ color: '#FF9800' }}
              >
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Tooltip>
          }
          title="Ürün Bilgileri"
        />
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent
            sx={{
              padding: '16px',
              backgroundColor: '#fff',
              borderRadius: '0 0 12px 12px'
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6} sx={{ display: 'flex' }}>
                <Box
                  sx={{
                    backgroundColor: '#F5EBE0',
                    borderRadius: '12px',
                    padding: '16px',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      fontSize: '13px',
                      color: '#333',
                      mb: 2,
                      letterSpacing: '0.5px'
                    }}
                  >
                    ALINAN ÜRÜN
                  </Typography>
                  <Box sx={{ '& > :not(style)': { mb: 2 } }}>
                    <Tooltip title="Alınan Ürün">
                      <TextField
                        id="input-with-icon-textfield"
                        label="Alınan Ürün"
                        size="small"
                        value={BuyStokNumber ? BuyStokNumber : ''}
                        fullWidth
                        disabled
                        variant="outlined"
                        onChange={(event) => {
                          changeBuyStokNumber(event.target.value);
                        }}
                        inputProps={{
                          style: { fontSize: '12px' }
                        }}
                        InputLabelProps={{
                          style: { fontSize: '11px', color: '#757575' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  setBuyStokNumber('');
                                }}
                              >
                                <CloseIcon
                                  size="small"
                                  sx={{ color: '#424242' }}
                                />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Tooltip>
                  </Box>
                  <Box sx={{ '& > :not(style)': { mb: 2 } }}>
                    <Tooltip title="Açıklama">
                      <TextField
                        id="input-with-icon-textfield"
                        label="Açıklama"
                        size="small"
                        fullWidth
                        variant="outlined"
                        value={buyProductDesc ? buyProductDesc : ''}
                        onChange={(event) => {
                          changeBuyStokProductDesc(event.target.value);
                        }}
                        inputProps={{
                          style: { fontSize: '12px' }
                        }}
                        InputLabelProps={{
                          style: { fontSize: '11px', color: '#757575' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                        }}
                      />
                    </Tooltip>
                  </Box>
                  <Box sx={{ '& > :not(style)': { mb: 2 } }}>
                    <TextField
                      label="Alınan Perakende Fiyat"
                      value={buyProductPrice}
                      onChange={(event) => {
                        changeBuyProductPrice(event.target.value);
                      }}
                      name="numberformat"
                      id="formatted-numberformat-input"
                      size="small"
                      fullWidth
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                        style: { fontSize: '12px' }
                      }}
                      InputLabelProps={{
                        style: { fontSize: '11px', color: '#757575' }
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                      }}
                      variant="outlined"
                    />
                  </Box>
                  {/* {invoiceData[0]?.Consumer?.ConsumerType === 3 && (
                    <Box sx={{ '& > :not(style)': { mb: 2 } }}>
                      <TextField
                        label="Alınan Toptan Fiyat"
                        value={buyProductWholesalePrice}
                        onChange={(event) => {
                          changeBuyProductWholesalePrice(event.target.value);
                        }}
                        name="numberformat"
                        id="formatted-numberformat-input-wholesale-buy"
                        size="small"
                        fullWidth
                        InputProps={{
                          inputComponent: NumberFormatCustom,
                          style: { fontSize: '12px' }
                        }}
                        InputLabelProps={{
                          style: { fontSize: '11px', color: '#757575' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                        }}
                        variant="outlined"
                      />
                    </Box>
                  )} */}
                  <Box sx={{ '& > :not(style)': { mb: 0 } }}>
                    <Tooltip title="Alınan Ürün Stok Adedi">
                      <TextField
                        id="input-with-icon-textfield"
                        label="Stok Adedi"
                        size="small"
                        value={buyStockTotal}
                        fullWidth
                        disabled
                        inputProps={{ style: { fontSize: '12px' } }}
                        InputLabelProps={{
                          style: { fontSize: '11px', color: '#757575' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                        }}
                        variant="outlined"
                        onChange={(event) => {
                          setBuyStockTotal(event.target.value);
                        }}
                      />
                    </Tooltip>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={6} sx={{ display: 'flex' }}>
                <Box
                  sx={{
                    backgroundColor: '#E3F2FD',
                    borderRadius: '12px',
                    padding: '16px',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      fontSize: '13px',
                      color: '#333',
                      mb: 2,
                      letterSpacing: '0.5px'
                    }}
                  >
                    VERİLEN ÜRÜN
                  </Typography>
                  <Box sx={{ '& > :not(style)': { mb: 2 } }}>
                    <Tooltip title="Verilen Ürün">
                      <TextField
                        id="input-with-icon-textfield"
                        label="Verilen Ürün"
                        size="small"
                        value={giveStokNumber ? giveStokNumber : ''}
                        fullWidth
                        variant="outlined"
                        onChange={(event) => {
                          changeGiveStokNumber(event.target.value);
                        }}
                        inputProps={{
                          style: { fontSize: '12px' }
                        }}
                        InputLabelProps={{
                          style: { fontSize: '11px', color: '#757575' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  setGiveStokNumber('');
                                }}
                              >
                                <CloseIcon
                                  size="small"
                                  sx={{ color: '#424242' }}
                                />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Tooltip>
                  </Box>
                  <Box sx={{ '& > :not(style)': { mb: 2 } }}>
                    <Tooltip title="Açıklama">
                      <TextField
                        id="input-with-icon-textfield"
                        label="Açıklama"
                        size="small"
                        value={giveProductDesc ? giveProductDesc : ''}
                        onChange={(event) => {
                          changeGiveStokProductDesc(event.target.value);
                        }}
                        fullWidth
                        variant="outlined"
                        inputProps={{
                          style: { fontSize: '12px' }
                        }}
                        InputLabelProps={{
                          style: { fontSize: '11px', color: '#757575' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                        }}
                      />
                    </Tooltip>
                  </Box>
                  <Box sx={{ '& > :not(style)': { mb: 2 } }}>
                    <TextField
                      label="Verilen Perakende Fiyat"
                      value={giveProductPrice}
                      onChange={(event) => {
                        changeGiveProductPrice(event.target.value);
                      }}
                      name="numberformat"
                      id="formatted-numberformat-input"
                      size="small"
                      fullWidth
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                        style: { fontSize: '12px' }
                      }}
                      InputLabelProps={{
                        style: { fontSize: '11px', color: '#757575' }
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                      }}
                      variant="outlined"
                    />
                  </Box>
                  {/* <Box sx={{ mb: 2 }}>
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item xs={2}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '40px',
                            borderRadius: '12px',
                            backgroundColor: '#f0eeff',
                            border: '1px solid #c4b5f4'
                          }}
                        >
                          <Box
                            component="img"
                            src={OlizIcon}
                            alt="Oliz"
                            sx={{ width: '1.8rem', height: '1.8rem', objectFit: 'contain' }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={10}>
                        <TextField
                          label="Oliz Fiyat"
                          value={olizPriceGiveProduct}
                          name="numberformat"
                          id="formatted-numberformat-input-oliz-give"
                          size="small"
                          disabled
                          fullWidth
                          variant="outlined"
                          autoComplete="off"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                            style: { fontSize: '12px' },
                            sx: {
                              '& .MuiInputBase-input.Mui-disabled': {
                                WebkitTextFillColor: '#212121'
                              }
                            }
                          }}
                          InputLabelProps={{
                            style: { fontSize: '11px', color: '#757575' }
                          }}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '12px',
                              '& fieldset': { borderColor: '#c4b5f4' }
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box> */}
                  <Box sx={{ '& > :not(style)': { mb: 2 } }}>
                    <Tooltip title="Verilen Ürün Depo Adı">
                      <TextField
                        id="input-with-icon-textfield"
                        label="Depo Adı"
                        size="small"
                        value={stockRegionName}
                        disabled
                        fullWidth
                        inputProps={{ style: { fontSize: '12px' } }}
                        InputLabelProps={{
                          style: { fontSize: '11px', color: '#757575' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                        }}
                        variant="outlined"
                        onChange={(event) => {
                          setStockRegionName(event.target.value);
                        }}
                      />
                    </Tooltip>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mb: 0
                    }}
                  >
                    <Tooltip title="Stok Adedi">
                      <TextField
                        id="input-with-icon-textfield"
                        label="Stok Adedi"
                        size="small"
                        fullWidth
                        inputProps={{ style: { fontSize: '12px' } }}
                        InputLabelProps={{
                          style: { fontSize: '11px', color: '#757575' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                        }}
                        variant="outlined"
                        disabled
                        value={stockTotal}
                        onChange={(event) => {
                          changeGiveStokTotal(event.target.value);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Sorgula">
                      <IconButton
                        className={classes.action}
                        size="large"
                        key="close"
                        onClick={() => {
                          diffModelStokControl();
                        }}
                      >
                        <SavedSearchIcon
                          sx={{ color: '#FF9800' }}
                          size="large"
                        />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Collapse>
      </Card>
      <Grid container spacing={2} style={{ paddingTop: 5 }}></Grid>
    </>
  );
}

export default DifferentModelSuggest;
